module.exports = __webpack_public_path__ + "static/media/curator-image.d437125c.jpg";